import { render, staticRenderFns } from "./CharacterAttributeValue.vue?vue&type=template&id=256c5068&lang=pug&"
import script from "./CharacterAttributeValue.vue?vue&type=script&lang=js&"
export * from "./CharacterAttributeValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterAttributeValue.vue"
export default component.exports